import { comma } from "./filter";
export default {
    install: function (Vue) {
        Vue.filter("comma", comma);
    }
};
//# sourceMappingURL=index.js.map